import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';

import { Field } from 'redux-form';

import IconButton from 'components/common/IconButton';
import TimepickerField from 'components/fields/TimepickerField';
import WeekdayField from 'components/fields/WeekdayField';
import IconCross from 'components/icons/IconCross';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

const styles = theme => ({
  gridContainer: {
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  gridTime: {
    width: 140,
  },
  gridWeekday: {
    flexShrink: 'unset',
  },
  typographySeparator: {
    paddingTop: 7,
  },
  iconCross: {
    width: 14,
    height: 14,
  },
  buttonDeleteSchedule: {
    margin: '-6px -20px -13px -13px',
  },
});

const ScheduleField = ({ name, className, onDelete, customise, classes }) => (
  <FormControl className={className}>
    <Grid
      className={classNames(className, classes.gridContainer)}
      container
      alignItems="flex-start"
      direction={customise ? 'row' : 'column-reverse'}
      spacing={24}
      wrap="nowrap"
    >
      <Grid item>
        <Grid
          className={className}
          container
          alignItems="flex-start"
          spacing={16}
          wrap="nowrap"
        >
          {customise &&
            <Grid item>
              <IconButton
                className={classes.buttonDeleteSchedule}
                onClick={onDelete}
                tooltipContent="Delete Schedule"
              >
                <IconCross className={classes.iconCross} />
              </IconButton>
            </Grid>
          }
          <Grid
            className={classes.gridTime}
            item
          >
            <Field
              id={`${name}.From`}
              name={`${name}.From`}
              component={TimepickerField}
              validate={[validate.required, validate.time]}
              normalize={normalize.time}
              placeholder="hh:mm am"
              fullWidth
              endIcon
            />
          </Grid>
          <Grid item>
            <Typography
              className={classes.typographySeparator}
              component="span"
            >
              to
            </Typography>
          </Grid>
          <Grid
            className={classes.gridTime}
            item
          >
            <Field
              id={`${name}.To`}
              name={`${name}.To`}
              component={TimepickerField}
              validate={[validate.required, validate.time]}
              normalize={normalize.timeDefaultPeriodPm}
              placeholder="hh:mm am"
              fullWidth
              endIcon
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        className={classes.gridWeekday}
        item
      >
        <Field
          id={`${name}['Weekday ID']`}
          name={`${name}['Weekday ID']`}
          component={WeekdayField}
          customise={customise}
        />
      </Grid>
    </Grid>
  </FormControl>
);

ScheduleField.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  customise: PropTypes.bool,
  classes: PropTypes.shape({
    gridTime: PropTypes.string.isRequired,
    gridWeekday: PropTypes.string.isRequired,
    typographySeparator: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
    buttonDeleteSchedule: PropTypes.string.isRequired,
  }).isRequired,
};

ScheduleField.defaultProps = {
  className: '',
  customise: false,
};

export default withStyles(styles)(ScheduleField);



// WEBPACK FOOTER //
// ./src/components/fields/ScheduleField.js